import { render, staticRenderFns } from "./BulkIssueBlockedTable.vue?vue&type=template&id=72bc6324&scoped=true"
import script from "./BulkIssueBlockedTable.vue?vue&type=script&lang=js"
export * from "./BulkIssueBlockedTable.vue?vue&type=script&lang=js"
import style0 from "./BulkIssueBlockedTable.vue?vue&type=style&index=0&id=72bc6324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bc6324",
  null
  
)

export default component.exports